import React from "react";
import "./authorizePaymentDialog.less";
import ButtonUI from "@/componentsUI/Button";
import PopupMask from "@/componentsUI/PopupMask";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";

interface AuthorizePaymentDialogProps {
  visible: boolean;
  onClose: () => void;
  paymentMethod?: string;
}

const AuthorizePaymentDialog: React.FC<AuthorizePaymentDialogProps> = ({
  visible,
  onClose,
  paymentMethod,
}) => {
  const { t } = useTranslationPlus("Wallet");

  return (
    <PopupMask visible={visible} onClose={onClose}>
      <div className="authorize-payment-dialog">
        <div className="dialog-header">
          <h3 className="dialog-title">{t("AuthorizePaymentTitle")}</h3>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="dialog-content">
          {paymentMethod === "MTN" ? (
            <>
              <p dir="auto">
                {t("AuthorizePaymentMTNIntro")}
              </p>
              <p dir="auto">{t("AuthorizePaymentProcessing")}</p>
            </>
          ) : (
            <>
              <p dir="auto">
                {t("AuthorizePaymentGenericIntro")}
              </p>
              <p dir="auto">{t("AuthorizePaymentProcessing")}</p>
            </>
          )}
        </div>
        <div className="dialog-footer">
          <ButtonUI type="primary" onClick={onClose} className="confirm-btn">
            {t("OK")}
          </ButtonUI>
        </div>
      </div>
    </PopupMask>
  );
};

export default AuthorizePaymentDialog;
